// The clock times a scheduled task or the morning brief can be set to, as FusionDropdown options.
//
// Replaces the native <input type="time">: its clock popup is drawn by the browser outside the page, so
// inside the iframe it detached and shifted whenever the host page scrolled — the same defect that moved
// the scheduled-task selects to FusionDropdown.

/** Minutes between offered times. */
export const TIME_STEP_MINUTES = 15;

/** "7:00" → "07:00". An input[type=time] silently rejects an unpadded value and renders blank. */
// Moved here from MorningBriefOptIn. The picker it fed is now a dropdown, which matches by ===, so an
// unpadded value still shows nothing: "7:05" is not the option "07:05".
export function padTime(value) {
  if (typeof value !== 'string') return '';
  const parts = value.split(':');
  if (parts.length < 2) return '';
  const hour = parts[0].padStart(2, '0');
  const minute = parts[1].padStart(2, '0');
  return `${hour}:${minute}`;
}

/** "07:05" -> "7:05 AM", the h:mm A shape ScheduledTaskRow prints, so the picker reads like the card. */
export function timeOfDayLabel(value) {
  const match = /^(\d{1,2}):(\d{2})/.exec(String(value || ''));
  if (!match) return String(value || '');
  const hours = Number(match[1]);
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  return `${hour12}:${match[2]} ${hours < 12 ? 'AM' : 'PM'}`;
}

/**
 * Every time of day at the step, as {value: 'HH:mm', label: 'h:mm AM'}, midnight first.
 *
 * A stored time off the grid ("07:05", or one set before this picker existed) is kept and slotted into
 * place, for the reason timezoneOptionsFor keeps an unlisted zone: a picker that dropped the current value
 * would rewrite the schedule as a side effect of opening the form. Returns a new array each call.
 */
export function timeOfDayOptions(current, stepMinutes = TIME_STEP_MINUTES) {
  const values = [];
  for (let minutes = 0; minutes < 24 * 60; minutes += stepMinutes) {
    const hh = String(Math.floor(minutes / 60)).padStart(2, '0');
    const mm = String(minutes % 60).padStart(2, '0');
    values.push(`${hh}:${mm}`);
  }
  const kept = padTime(current);
  if (kept && !values.includes(kept)) {
    values.push(kept);
    values.sort();
  }
  return values.map(value => ({ value, label: timeOfDayLabel(value) }));
}
